import { gql } from '@apollo/client';

export const GET_SUBSIDY_REQUESTS_REPORT = gql`
  query GetSubsidyRequestsReport($input: SubsidyRequestsReportInput!) {
    subsidyRequestsReport(input: $input) {
      totalSubsidy
      contractedDealsTotalSubsidy
      openDealsTotalSubsidy
      totalFinanceVolume
      totalDeals
      contractedDeals
      openDeals
      avgSubsidyPercentage
      avgSubsidyPercentageRangeMin
      avgSubsidyPercentageRangeMax
      avgSubsidyPerContractedDeal
      subsidyRequestsTotal
      subsidyRequests {
        subsidyRequestId
        customer
        dealer
        lender
        term
        financeAmount
        subsidyPercentage
        dnetPercentage
        dnet
        approvedSubsidyAmount
        equipment {
          id
          year
          make
          model
          serialNumberVin
        }
      }
    }
  }
`;
